
import KPICard from "./KPICardNew";

export const ExecutiveMetricsGrid = (props) => {

  const {openKPIPopup, closeKPIPopup, loadingMap, dataMap} = props
    return (
      <div className="kpi-grid" style={{ 
        display: "flex",            
        gap: "2px",
        overflowX: "auto",          
        paddingBottom: "12px",      
        WebkitOverflowScrolling: "touch", 
        scrollbarWidth: "thin",     
        boxSizing: "border-box",
        maxWidth:"1280px"
      }}>
        
        <KPICard 
          title="Sales (MTD)" 
          valueField="NetAmount" 
          icon="🛍️" 
          trend="14.2%" 
          up={true}
          subtitle="vs target"
          graphData={[28, 32, 30, 38, 35, 42]} // Spike up
          color="#e6f7ed"
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Sales (MTD)")}}
          loadingMap ={loadingMap}
          dataMap={dataMap}
        />

        {/* 1. Daily Sales */}
        <KPICard 
          title="Daily Sales" 
          valueField="NetAmount" 
          icon="🛍️" 
          trend="14.2%" 
          up={true}
          subtitle="vs target"
          graphData={[28, 32, 30, 38, 35, 42]} // Spike up
          color="#e6f7ed"
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Daily Sales")}}
          loadingMap ={loadingMap}
          dataMap={dataMap}
        />
  
        {/* 2. Collection */}
        <KPICard 
          title="Collection (MTD)" 
          valueField="MonthTotalCollection" 
          icon="💰" 
          trend="8.3%" 
          up={true}
          subtitle="92% recovery"
          graphData={[310, 325, 340, 335, 360, 385]} // Steady climb
          color="#fff0f5" 
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Collection (MTD)")}}
          loadingMap ={loadingMap}
          dataMap={dataMap}
          
        />
  
        {/* 3. Profit */}
        <KPICard 
          title="Net Profit" 
          valueField="NetProfit" 
          icon="📈" 
          trend="3.1%" 
          up={true}
          subtitle="Margin: 24.5%"
          graphData={[115, 118, 112, 120, 122, 124]} // Growth
          color="#f3efff"     
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Net Profit")}}
          loadingMap ={loadingMap}
          dataMap={dataMap}
        />
  
        {/* 4. Receivables */}
        <KPICard 
          title="Receivables" 
          valueField="TotalReceivables" 
          icon="⏳" 
          trend="-2.4%" 
          up={true} // Drop in receivables is a corporate win
          subtitle="Avg aging: 18d"
          graphData={[110, 105, 108, 99, 97, 94]} // Clean downward curve
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Receivables")}}
          color="#fff2e6"
           loadingMap ={loadingMap}
          dataMap={dataMap}
        />
  
        {/* 5. Cash */}
        <KPICard 
          title="Cash Balance" 
          valueField="CashBalance" 
          icon="💵" 
          trend="0.8%"
          subtitle="Operational cash"
          graphData={[75, 76, 74, 79, 77, 78]} // Stable fluctuating wave
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Cash Balance")}}
          color="#e6f4ff"
          loadingMap ={loadingMap}
         dataMap={dataMap}
        />
  
        {/* 6. Bank Balance */}
        <KPICard 
          title="Bank Balance" 
          valueField="TotalBankBalance" 
          icon="🏛️" 
          trend="5.7%"
          subtitle="3 Active accounts"
          graphData={[1.31, 1.34, 1.35, 1.39, 1.40, 1.42]} // Consistent gains
          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("Bank Balance")}}
          color="#fefce8"
          loadingMap ={loadingMap}
          dataMap={dataMap}
        />
  
        {/* 7. PDC In Hand */}
        <KPICard 
          title="PDC Received" 
          valueField="amt" 
          icon="📥" 
          trend="12.5%"
          subtitle="6 checks clearing"
          graphData={[85, 90, 120, 105, 100, 112]} // Irregular waves

          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("PDC Received")}}
          color="#faf0ff"
          loadingMap ={loadingMap}
          dataMap={dataMap}
        />
  
        {/* 8. PDC Issued */}
        <KPICard 
          title="PDC Issued" 
          valueField="amt" 
          icon="📤" 
          trend="1.5%"
          up={false} // Rising committed liabilities is negative
          subtitle="Due next 30 days"
          graphData={[55, 58, 62, 60, 61, 64]} // Rising commitments

          onClick={() => { console.log("showKPIPopup") ; openKPIPopup("PDC Issued")}}
          color="#f0fdf4"
          loadingMap ={loadingMap}
          dataMap={dataMap}
        />
  
      </div>
    );
  };
